// _scene-gravity.js — the scene's gravity vector (DECISION-019 sub-decision 5: scene gravity required from v1, default
// Earth), resolved with NO physics engine: placement reads "up" from it (`stage._upVector`) on every customer scene, while
// the cannon-es world that simulates bodies is lazy (`_physics-world.js`, ASK-177 §13a item 5).
export const EARTH_GRAVITY = Object.freeze({ x: 0, y: -9.81, z: 0 });

/** The gravity vector from a scene's manifest field (`{ x, y, z }` in m/s²); Earth when absent or any component is
 *  non-finite. `isDefault` = the scene declared none. */
export function resolveGravity(sceneGravity) {
	const g = sceneGravity ?? EARTH_GRAVITY;
	const x = Number.isFinite(g?.x) ? g.x : EARTH_GRAVITY.x;
	const y = Number.isFinite(g?.y) ? g.y : EARTH_GRAVITY.y;
	const z = Number.isFinite(g?.z) ? g.z : EARTH_GRAVITY.z;
	return { x, y, z, isDefault: sceneGravity == null };
}
